import React from "react";
import Navigation from "../utils/Navigation";
import "../../css/about/company.css";

import bridge from "../../images/about/company/iconBridge.webp";
import stanok from "../../images/about/company/iconStanok.webp";
import silos from "../../images/about/company/iconSilos.webp";

import img1 from "../../images/about/company/image_sespel_1.webp";
import img2 from "../../images/about/company/image_sespel_2.webp";
import img3 from "../../images/about/company/image_sespel_3.webp";
import img4 from "../../images/about/company/image_sespel_4.webp";
import img5 from "../../images/about/company/image_sespel_5.webp";
import img6 from "../../images/about/company/image_sespel_6.webp";
import img7 from "../../images/about/company/image_sespel_7.webp";
import img8 from "../../images/about/company/image_sespel_8.webp";
import img9 from "../../images/about/company/image_sespel_9.webp";
import img10 from "../../images/about/company/image_sespel_10.webp";
import img11 from "../../images/about/company/image_sespel_11.webp";
import img12 from "../../images/about/company/image_sespel_12.webp";
import {NewsPhoto} from "../news/NewsCard";
import {useLocation} from "react-router-dom";
import {findElementByLink} from "../utils/siteStructure";
import siteStructure from "../siteStructure.json";
import SeoHelmet from "../utils/seo";
import {useTheme} from "../header/Header";

export function CompanyMainIndicatorsText({bigText, smallText, vertical=false}){

    const {theme} = useTheme()

    return (
        <div className={`company-indicators-text ${theme} ${vertical? "company-indicators-text-vertical" : "company-indicators-text-horizontal"}`}>
            <h1>{bigText}</h1>
            <p>{smallText}</p>
        </div>
    )
}

export default function Company() {

    const location = useLocation();
    const siteData = findElementByLink(siteStructure, location.pathname)
    const seo = siteData !== null && siteData.seo? siteData.seo : {title:"", description:"", keywords:"", changefreq: 'yearly', priority: 0.4}
    const { theme } = useTheme()

    return (
        <>
            <SeoHelmet
                title={seo.title}
                description={seo.description}
                keywords={seo.keywords}
            />
            <Navigation/>
            <div className={`complexBack ${theme}`}> </div>

            <div className={`company-container ${theme}`}>

                <Description title={"ЧЕБОКСАРСКОЕ ПРЕДПРИЯТИЕ «СЕСПЕЛЬ» - САМЫЙ СОВРЕМЕННЫЙ ЗАВОД"} content={<Content theme={theme}/>}
                             images={[img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12]}/>

                <h1>Основные показатели</h1>
                <CompanyMainIndicatorsContent/>

                <h1>Основная продукция</h1>
                <CompanyMainProductsContent/>
            </div>

        </>
    );
}

function Description({title, content, images}) {
    return (
        <div>
            <h3>{title}</h3>
            <NewsPhoto images={images}/>
            <div>{content}</div>
        </div>
    );
}

function CompanyMainProducts({images, titles, texts}){

    return (
        <div className={"company-product"}>
            <div className={"company-product-imageWrapper"}>
                {images.map((img,i)=>{
                    return <img key={`img-${i}`} src={img} alt=""/>
                })}
            </div>

            {titles.map((title, i)=> {
                return <div key={`title-${i}`}>
                    <h3>{title}</h3>
                    {texts[i]? texts[i].map((text, j)=>{
                        return <p key={`text-${i}-${j}`}>{text}</p>
                    }) : null}
                </div>
            })}

        </div>
    )
}

function Content({theme}) {
    return (
        <>
            <div className={`company-product-description ${theme}`}>
                <p>Целью деятельности предприятия является оказание
                    всесторонней поддержки нашим клиентам, работающим
                    в сфере транспорта, строительства, сельского хозяйства,
                    нефтегазового комплекса, химической, пищевой и перерабатывающей
                    промышленности.</p>

                <p>
                    Нашей первоочередной задачей является безусловное
                    ориентирование на Ваши потребности. Для этого мы прислушиваемся к Вам,
                    адаптируя свои решения к Вашим индивидуальным нуждам и готовы в любой
                    ситуации оказать Вам необходимую помощь и предлагаем Вам широкий спектр
                    специализированных цистерн. Номенклатурный ряд которых составляет более
                    150 моделей из низколегированной, нержавеющей стали и алюминиевого сплава.
                </p>

                <p>Мы производим и поставляем полуприцепы, цистерны -  цементовозы, муковозы,
                    бензовозы, нефтевозы,  битумовозы, цистерны подъемного типа, водовозы,
                    комбикормовозы, цистерны для химической продукции.
                    Наш многолетний опыт работы в качестве одного из ведущих Российских
                    поставщиков специализированной техники делает нас компетентным партнером
                    в области решений по перевозке сыпучих и жидких грузов.</p>

            </div>
            <div className={`company-product-description ${theme}`}>

                <strong>ПРИОБРЕТАЯ ТЕХНИКУ ЗАО «ЧЕБОКСАРСКОЕ ПРЕДПРИЯТИЕ «СЕСПЕЛЬ», ВЫ ПОЛУЧАЕТЕ:</strong>
                <ul>
                    <li>
                        инновационные технические решения в производстве техники, обеспечивающие эффективность производственных процессов и выполнение самых строгих требований клиентов;
                    </li>
                    <li>
                        поддержку предприятия по техобслуживанию техники на производственной площадке завода, дилеров и сервисных площадках партнеров, расположенных во многих регионах России, обеспечивая этим легкую территориальную доступность;
                    </li>
                    <li>
                        специализированные цистерны, собранные на новейшем технологическом оборудовании импортного и российского производства, максимально адаптированные к Российским дорогам, по ценам на 40%-80% ниже цен производителей аналогичной европейской техники.
                    </li>
                </ul>

                <br/>

                <strong>ДРУГИЕ ПРЕИМУЩЕСТВА:</strong>
                <ul>
                    <li>
                        Уникальные технологии производства и современное оборудование;
                    </li>
                    <li>
                        Использование в производстве высокопрочных материалов;
                    </li>
                    <li>
                        Инновационный контроль качества продукции;
                    </li>
                    <li>
                        Разработка и производство спецтехники по индивидуальным заказам;
                    </li>
                    <li>
                        Постоянно в наличии на складе более 100 единиц техники;
                    </li>
                    <li>
                        Комплексные центры сервисного оборудования по всей России.
                    </li>
                </ul>
            </div>
        </>
    )
}

function CompanyMainIndicatorsContent() {

    function createIndicatorsContent(bigText, smallText) {
        return {bigText, smallText}
    }

    const content = {
        years: createIndicatorsContent("33", "года на рынке"),
        area: createIndicatorsContent("30 000", "кв.м. производственных площадей"),
        shop: createIndicatorsContent("7", "цехов"),
        research: createIndicatorsContent("3", "исследовательских центра"),
        employee: createIndicatorsContent("700", "сотрудников"),
        age: createIndicatorsContent("39", "лет средний возраст"),
        revenue: createIndicatorsContent(">6 000", "млн. руб. выручка компании за 2024 год"),
        invistibles: createIndicatorsContent(">500", "млн. руб. инвестиции в R&D"),
        ppc: createIndicatorsContent(">10 000", "произведенных полуприцепов"),
        machine: createIndicatorsContent(">20", "произведенных уникальных станочных комплексов"),
        welding: createIndicatorsContent(">300", "км/год сварки"),
        molding: createIndicatorsContent(">1 000", "т/год промышленного литья"),
    }

    return (
        <div className={"company-main-indicators"}>
            <div>
                <div>
                    <CompanyMainIndicatorsText {...content.years} vertical={true}/>
                    <CompanyMainIndicatorsText {...content.area} vertical={true}/>
                    <CompanyMainIndicatorsText {...content.shop} vertical={true}/>
                    <CompanyMainIndicatorsText {...content.research} vertical={true}/>
                    <CompanyMainIndicatorsText {...content.employee} vertical={true}/>
                    <CompanyMainIndicatorsText {...content.age} vertical={true}/>
                </div>
            </div>
            <div>
                <CompanyMainIndicatorsText {...content.ppc} vertical={true}/>
                <CompanyMainIndicatorsText {...content.machine} vertical={true}/>
                <CompanyMainIndicatorsText {...content.welding} vertical={true}/>
                <CompanyMainIndicatorsText {...content.molding} vertical={true}/>
                <CompanyMainIndicatorsText {...content.invistibles} vertical={true}/>
                <CompanyMainIndicatorsText {...content.revenue} vertical={true}/>
            </div>
        </div>
    )
}

function CompanyMainProductsContent() {

    function createProductsContent(images, titles, texts) {
        return {images, titles, texts}
    }

    const content = {
        bridge: createProductsContent([bridge],["Алюминиевые мосты"],
            [["Пролеты от 12 до 18 м", "Длина моста 50-250 м"]]),
        silos: createProductsContent([silos],["Алюминиевые силосы и резервуары"],
            [["Высота от 7,6 до 50 м", "Диаметр от 2,4 м до", "неограниченно"]]),
        stanok: createProductsContent([stanok],["Станочные комплексы"],
            [["СТП Прогресс","СТП Сеспель","СТП Зерновоз","СТП 4ПЛ","СТП ШВП","РТК Лазер","Мобильный СТП","Проект Центратор", "Проект КЛОН", "и др."]]),
    }

    return (
        <div className={"company-products"}>
            <CompanyMainProducts {...content.bridge}/>
            <CompanyMainProducts {...content.silos}/>
            <CompanyMainProducts {...content.stanok}/>
        </div>
    )
}
